import React from "react";
import { Route } from "react-router-dom";
import isApp from "shared/util/isApp";
import AnimatedLocations from "shared/components/AnimatedLocations";

import SplashMobile from "apps/splash_mobile/App";
import SplashDesktop from "apps/splash_desktop/App";
import OldLogin from "apps/login_old";
import Login from "apps/login";
import Logout from "apps/logout";
import Signup from "apps/signup";


import "./App.scss";

if (process.env.PLATFORM === "desktop") {
	require("./App.desktop.scss");
}

// though the apps suffer from the same 300ms delay that websites do, we cannot
// enable fastclick on the apps because it just does not work correctly:
// * onboarding pages with two consecutive select fields trigger the second to
//   be focused when you click the first
// * oknf toggles seem to get locked up and confused
if (!process.env.TESTING && !isApp()) {
	require("react-fastclick");
}

const PAGE_SPEED = 400;

const SplashComponent = process.env.PLATFORM === "desktop" ? SplashDesktop : SplashMobile;

// ios launches at /login, which makes splash render
// then we direct them to login-direct when they click signin
const loginRoute = isApp() ? "/login-direct(/*)" : "/login(/*)";

const LoggedoutPage = () => (
	<AnimatedLocations
		transitionName="loggedoutpage"
		transitionEnterTimeout={PAGE_SPEED}
		transitionLeaveTimeout={PAGE_SPEED}
		showAnimation={false}
	>
		<Route path="/logout" component={Logout} />

		<Route path={loginRoute} component={Login} />

		{/* auto-login links that fail (this happens when the account is disabled */}
		<Route path="/l/:autologinToken" component={OldLogin} />

		<Route path="/signup(/*)" component={Signup} />

		<Route path="/" component={SplashComponent} />

		{/* Used as a paid acq landing page */}
		<Route path="/joinus(/*)" component={Signup} />

		{/* not found, render splash */}
		<Route component={SplashComponent} />
	</AnimatedLocations>
);

export default LoggedoutPage;



// WEBPACK FOOTER //
// ./src/pages/loggedout/App.jsx